import i18n from "@/i18n";
import { languagesModule } from "@/store";
import { loadLanguagesOnce, buildNotFoundTarget } from "@/router/guards/utils";
import { getDefaultLang, isValidLang, isDefaultLang } from "@/utils/locale";
import router from "./router";

router.beforeEach(async (to, from, next) => {
  try {
    await loadLanguagesOnce();

    const rawLocale = to.params.locale as string | undefined;
    const defaultLang = getDefaultLang();

    if (!rawLocale) {
      if (i18n.global.locale.value !== defaultLang) {
        i18n.global.locale.value = defaultLang;
      }

      if (languagesModule.getActiveLanguageCode !== defaultLang) {
        languagesModule.SetLanguageByCode(defaultLang);
      }

      return next();
    }

    const valid = isValidLang(rawLocale);
    if (!valid) {
      return next(buildNotFoundTarget(to, false));
    }

    if (i18n.global.locale.value !== rawLocale) {
      i18n.global.locale.value = rawLocale;
    }

    if (languagesModule.getActiveLanguageCode !== rawLocale) {
      languagesModule.SetLanguageByCode(rawLocale);
    }

    if (isDefaultLang(rawLocale) && to.fullPath !== "/") {
      return next({
        path: "/",
        query: to.query,
        hash: to.hash,
        replace: true,
      });
    }

    return next();
  } catch (e) {
    console.error("Locale guard error:", e);
    return next();
  }
});
